<template>
    <breeze-authenticated-layout>
        <template #header>
            <div class="flex justify-between items-center">
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    Resource Items
                </h2>
            </div>
        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
                    <div class="p-6 bg-white border-b border-gray-200">
                        <div class="flex flex-col">
                            <div
                                class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8"
                            >
                                <div
                                    class="
                                        py-2
                                        align-middle
                                        inline-block
                                        min-w-full
                                        sm:px-6
                                        lg:px-8
                                    "
                                >
                                    <div
                                        class="
                                            shadow
                                            overflow-hidden
                                            border-b border-gray-200
                                            sm:rounded-lg
                                        "
                                    >
                                        <table
                                            class="
                                                min-w-full
                                                divide-y divide-gray-200
                                            "
                                        >
                                            <thead class="bg-gray-50">
                                                <tr>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        #
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Title
                                                    </th>

                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Order Number
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Note
                                                    </th><th
                                                    scope="col"
                                                    class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                >
                                                    Wheel Note
                                                </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            relative
                                                            px-6
                                                            py-3
                                                        "
                                                    >
                                                        Live
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            relative
                                                            px-6
                                                            py-3
                                                        "
                                                    >
                                                        <span class="sr-only"
                                                            >Edit</span
                                                        >
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody
                                                class="
                                                    bg-white
                                                    divide-y divide-gray-200
                                                "
                                            >
                                                <tr
                                                    v-for="(
                                                        content, index
                                                    ) in contents"
                                                    :key="content.id"
                                                >
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                    >
                                                        {{ index + 1 }}
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                    >
                                                        {{ content.title }}
                                                    </td>

                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                            text-sm
                                                            text-gray-500
                                                        "
                                                    >
                                                        {{
                                                            content.order_number
                                                        }}
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            text-sm
                                                            whitespace-pre
                                                            text-gray-500
                                                        "
                                                    >
                                                        <div
                                                            class="
                                                                max-w-xs
                                                                max-h-40
                                                                overflow-auto
                                                            "
                                                            v-html="
                                                                content.note
                                                            "
                                                        ></div>
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            text-sm
                                                            whitespace-pre
                                                            text-gray-500
                                                        "
                                                    >
                                                        <div
                                                            class="
                                                                max-w-xs
                                                                max-h-40
                                                                overflow-auto
                                                            "
                                                            v-html="
                                                                content.wheelNote
                                                            "
                                                        ></div>
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                            text-sm
                                                            text-gray-500
                                                        "
                                                    >
                                                        <span
                                                            :class="{
                                                                'bg-green-100 text-green-800':
                                                                    content.live,
                                                                'bg-red-100 text-red-800':
                                                                    !content.live,
                                                            }"
                                                            class="
                                                                px-2
                                                                inline-flex
                                                                text-xs
                                                                leading-5
                                                                font-semibold
                                                                rounded-full
                                                            "
                                                        >
                                                            {{
                                                                content.live
                                                                    ? "Yes"
                                                                    : "No"
                                                            }}
                                                        </span>
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                            text-right text-sm
                                                            font-medium
                                                        "
                                                    >
                                                        <button
                                                            type="button"
                                                            @click="
                                                                edit(content)
                                                            "
                                                            class="
                                                                text-green-600
                                                                hover:text-green-900
                                                                mx-3
                                                                focus:outline-none
                                                            "
                                                        >
                                                            Edit
                                                        </button>
                                                        <inertia-link
                                                            :href="
                                                                route(
                                                                    'admin.plans.resource.content.index',
                                                                    {
                                                                        plan: content.component,
                                                                        resource:
                                                                            content.id,
                                                                    }
                                                                )
                                                            "
                                                            class="
                                                                text-indigo-600
                                                                hover:text-indigo-900
                                                            "
                                                            >Manage
                                                        </inertia-link>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </breeze-authenticated-layout>
    <dialog-model :show="open" @close="close">
        <template v-slot:title> Edit the resource. </template>
        <template v-slot:content>
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
                <div class="block w-full">
                    <label
                        for="title"
                        class="block text-sm font-medium text-gray-700"
                        >Title</label
                    >
                    <input
                        v-model="form.title"
                        type="text"
                        name="title"
                        id="title"
                        autocomplete="organization-title"
                        class="
                            mt-1
                            focus:ring-indigo-500 focus:border-indigo-500
                            block
                            w-full
                            shadow-sm
                            sm:text-sm
                            border-gray-300
                            rounded-md
                        "
                    />
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.resource.title"
                    />
                </div>
                <div class="block w-full">
                    <label
                        for="ordernumber"
                        class="block text-sm font-medium text-gray-700"
                        >Order Number</label
                    >
                    <input
                        v-model="form.order_number"
                        type="number"
                        name="ordernumber"
                        id="ordernumber"
                        class="
                            mt-1
                            focus:ring-indigo-500 focus:border-indigo-500
                            block
                            w-full
                            shadow-sm
                            sm:text-sm
                            border-gray-300
                            rounded-md
                        "
                    />
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.resource.order_number"
                    />
                </div>
                <div class="block w-full">
                    <label
                        for="note"
                        class="block text-sm font-medium text-gray-700"
                    >Note</label
                    >
                    <textarea
                        v-model="form.note"
                        id="note"
                        name="note"
                        rows="3"
                        class="
                            shadow-sm
                            focus:ring-indigo-500 focus:border-indigo-500
                            mt-1
                            block
                            w-full
                            sm:text-sm
                            border border-gray-300
                            rounded-md
                        "
                    />
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.resource.note"
                    />
                </div>
                <div class="block w-full">
                    <label
                        for="noteLive"
                        class="block text-sm font-medium text-gray-700"
                    >Note Live</label
                    >
                    <select
                        v-model="form.noteLive"
                        id="noteLive"
                        name="noteLive"
                        autocomplete="off"
                        class="
                            mt-1
                            block
                            w-full
                            py-2
                            px-3
                            border border-gray-300
                            bg-white
                            rounded-md
                            shadow-sm
                            focus:outline-none
                            focus:ring-indigo-500
                            focus:border-indigo-500
                            sm:text-sm
                        "
                    >
                        <option value="">Note is Live or not?</option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                    </select>
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.resource.noteLive"
                    />
                </div>
                <div class="block w-full">
                    <label
                        for="noteLive"
                        class="block text-sm font-medium text-gray-700"
                    >Wheel Area Live</label
                    >
                    <select
                        v-model="form.wheelLive"
                        id="noteLive"
                        name="noteLive"
                        autocomplete="off"
                        class="
                            mt-1
                            block
                            w-full
                            py-2
                            px-3
                            border border-gray-300
                            bg-white
                            rounded-md
                            shadow-sm
                            focus:outline-none
                            focus:ring-indigo-500
                            focus:border-indigo-500
                            sm:text-sm
                        "
                    >
                        <option value="">Wheel area is Live or not?</option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                    </select>
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.resource.wheelLive"
                    />
                </div>
                <div class="block w-full">
                    <label
                        for="note"
                        class="block text-sm font-medium text-gray-700"
                    >Wheel Note</label
                    >
                    <textarea
                        v-model="form.wheelNote"
                        id="note"
                        name="note"
                        rows="3"
                        class="
                            shadow-sm
                            focus:ring-indigo-500 focus:border-indigo-500
                            mt-1
                            block
                            w-full
                            sm:text-sm
                            border border-gray-300
                            rounded-md
                        "
                    />
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.resource.wheelNote"
                    />
                </div>
                <div class="block w-full">
                    <label
                        for="noteLive"
                        class="block text-sm font-medium text-gray-700"
                    >Wheel Note Live</label
                    >
                    <select
                        v-model="form.wheelNoteLive"
                        id="noteLive"
                        name="noteLive"
                        autocomplete="off"
                        class="
                            mt-1
                            block
                            w-full
                            py-2
                            px-3
                            border border-gray-300
                            bg-white
                            rounded-md
                            shadow-sm
                            focus:outline-none
                            focus:ring-indigo-500
                            focus:border-indigo-500
                            sm:text-sm
                        "
                    >
                        <option value="">Wheel Note is Live or not?</option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                    </select>
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.resource.wheelNoteLive"
                    />
                </div>
                <div class="block w-full">
                    <label
                        for="live"
                        class="block text-sm font-medium text-gray-700"
                        >Live</label
                    >
                    <select
                        v-model="form.live"
                        id="live"
                        name="live"
                        autocomplete="off"
                        class="
                            mt-1
                            block
                            w-full
                            py-2
                            px-3
                            border border-gray-300
                            bg-white
                            rounded-md
                            shadow-sm
                            focus:outline-none
                            focus:ring-indigo-500
                            focus:border-indigo-500
                            sm:text-sm
                        "
                    >
                        <option value="">Content is Live or not?</option>
                        <option value="1">Yes</option>
                        <option value="0">No</option>
                    </select>
                    <input-error
                        v-if="form.hasErrors"
                        :message="form.errors.resource.live"
                    />
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <button
                type="button"
                class="
                    w-full
                    inline-flex
                    justify-center
                    rounded-md
                    border border-transparent
                    shadow-sm
                    px-4
                    py-2
                    bg-green-600
                    text-base
                    font-medium
                    text-white
                    hover:bg-green-700
                    focus:outline-none
                    focus:ring-2
                    focus:ring-offset-2
                    focus:ring-green-500
                    sm:ml-3 sm:w-auto sm:text-sm
                "
                @click="submit()"
            >
                Save
            </button>
            <button
                type="button"
                class="
                    mt-3
                    w-full
                    inline-flex
                    justify-center
                    rounded-md
                    border border-gray-300
                    shadow-sm
                    px-4
                    py-2
                    bg-white
                    text-base
                    font-medium
                    text-gray-700
                    hover:bg-gray-50
                    focus:outline-none
                    focus:ring-2
                    focus:ring-offset-2
                    focus:ring-indigo-500
                    sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm
                "
                @click="close()"
                ref="cancelButtonRef"
            >
                Cancel
            </button>
        </template>
    </dialog-model>
</template>
<script>
import BreezeAuthenticatedLayout from "@/Layouts/Authenticated";
import DialogModel from "@/Components/DialogModel";
import InputError from "@/Components/InputError";
import { useForm } from "@inertiajs/inertia-vue3";
export default {
    data() {
        return {
            open: false,
            editItemIndex: -1,
            form: useForm(
                {
                    id: "",
                    title: "",
                    order_number: "",
                    live: "",
                    note: "",
                    noteLive: "",
                    wheelLive: "",
                    wheelNoteLive: "",
                    wheelNote: ""
                },
                {
                    bag: "resource",
                }
            ),
        };
    },
    props: {
        contents: Array,
        slug: String,
    },
    methods: {
        close() {
            this.form.clearErrors();
            this.form.reset();
            this.open = false;
            this.editItemIndex = -1;
        },
        submit() {
            // update request
            this.form.put(
                route("admin.plans.resource.update", {
                    plan: this.slug,
                    resource: this.form.id,
                }),
                {
                    onSuccess: () => this.close(),
                    preserveScroll: true,
                }
            );
        },
        edit(resource) {
            this.editItemIndex = this.contents.indexOf(resource);
            this.form.title = resource.title;
            this.form.order_number = resource.order_number;
            this.form.id = resource.id;
            this.form.live = resource.live ? 1 : 0;
            this.form.noteLive = resource.noteLive ? 1 : 0;
            this.form.note = resource.note;
            this.form.wheelLive = resource.wheelLive ? 1 : 0;
            this.form.wheelNote = resource.wheelNote;
            this.form.wheelNoteLive = resource.wheelNoteLive ? 1 : 0;
            this.open = true;
        },
    },
    components: {
        BreezeAuthenticatedLayout,
        DialogModel,
        InputError,
    },
};
</script>
